export default "__VITE_ASSET__BRYhs5Nn__"